/**
 * ReadReceipt Component - Web Dashboard
 * Visual indicators for message delivery status
 *
 * States:
 * - sending: Clock icon (gray)
 * - sent: Single check (gray)
 * - delivered: Double check (gray)
 * - read: Double check (blue)
 */


import { Check, CheckCheck, Clock } from 'lucide-react';

export type MessageStatus = 'sending' | 'sent' | 'delivered' | 'read';

interface ReadReceiptProps {
  status: MessageStatus;
  className?: string;
}

export function ReadReceipt({ status, className = '' }: ReadReceiptProps) {
  const baseClass = `inline-flex items-center transition-colors duration-200 ${className}`;

  switch (status) {
    case 'sending':
      return (
        <span className={`${baseClass} text-gray-400`} title="กำลังส่ง...">
          <Clock className="w-3.5 h-3.5" />
        </span>
      );

    case 'sent':
      return (
        <span className={`${baseClass} text-gray-400`} title="ส่งแล้ว">
          <Check className="w-3.5 h-3.5" />
        </span>
      );

    case 'delivered':
      return (
        <span className={`${baseClass} text-gray-400`} title="ส่งถึงแล้ว">
          <CheckCheck className="w-3.5 h-3.5" />
        </span>
      );

    case 'read':
      return (
        <span className={`${baseClass} text-blue-500`} title="อ่านแล้ว">
          <CheckCheck className="w-3.5 h-3.5" />
        </span>
      );

    default:
      return null;
  }
}

export default ReadReceipt;
